@if (visible$ | async) {
  <div class="container">
    <div class="header">
      <div>
        <span class="header-icon ph-duotone ph-chats-circle"></span>
        @let thread = threadHydratedId();
        @if (thread && thread.item.title) {
          <a
            class="alg-link header-title"
            [routerLink]="thread.item.route | url"
          >
            {{ thread.item.title }}
          </a>
        }
      </div>
      <button
        class="header-button size-s"
        type="submit"
        icon="ph ph-x"
        alg-button-icon
        (click)="onClose()"
      ></button>
    </div>
    <alg-thread class="thread"></alg-thread>
  </div>
}
